import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { LEAVE_STATE_CONST } from 'constant';

interface LeavesState {
  allLeaveRequests: {
    isCalendarView: boolean;
    prevPageNumber: number;
  };
}

const storedLeavesState = sessionStorage.getItem(LEAVE_STATE_CONST);

const initialState: LeavesState = storedLeavesState
  ? JSON.parse(storedLeavesState)
  : {
      allLeaveRequests: {
        isCalendarView: false,
        prevPageNumber: 0,
      },
    };

const LeavesSlice = createSlice({
  name: 'Leaves',
  initialState,
  reducers: {
    setCalendarView(state, action: PayloadAction<boolean>) {
      state.allLeaveRequests.isCalendarView = action.payload;
      sessionStorage.setItem(LEAVE_STATE_CONST, JSON.stringify(state));
    },
    setPrevPageNumberInStore(state, action: PayloadAction<number>) {
      state.allLeaveRequests.prevPageNumber = action.payload;
      sessionStorage.setItem(LEAVE_STATE_CONST, JSON.stringify(state));
    },
  },
});

export const { setCalendarView, setPrevPageNumberInStore } = LeavesSlice.actions;
export default LeavesSlice.reducer;
